export const aboutInfo = {
  brandName: "亚洲精品",
  tagline: "甄选亚洲顶级品质产品与品牌",
  introduction: "亚洲精品成立于2020年，是一家专注于推荐和展示亚洲各国顶级品质商品的精选内容平台。我们汇聚来自中国、日本、韩国、泰国、印度、越南等12个亚洲国家和地区的优质品牌，涵盖时尚服饰、美妆护肤、美食特产、工艺精品四大核心品类。",
  mission: "让每一位追求品质生活的消费者，都能轻松发现和享受来自亚洲的极致精品体验。我们相信，每一件优秀的亚洲产品背后，都有着独特的文化故事和匠心工艺。",
  story: `亚洲精品的创立源于创始团队在亚洲各国的旅行经历。在旅途中，我们发现每个国家都有着令人惊叹的优质产品和工艺，但由于信息不对称，很多优秀的品牌和产品难以被更多消费者了解和获取。

于是，我们决定建立一个平台，专门挖掘和推荐亚洲各国的精品好物。我们的买手团队遍布亚洲各国，每年深入上百个城市和地区，实地探访品牌工厂、手工作坊和设计师工作室，只为发现那些真正值得推荐的产品。

从最初的一个博客网站，到如今覆盖数百万用户的精选推荐平台，亚洲精品始终坚持严格的选品标准和真诚的推荐态度。我们不追求数量，只推荐经过团队亲身体验和严格评测的高品质产品。`,
  values: [
    { title: "品质至上", description: "每一件推荐产品都经过严格的评测流程，确保品质卓越", icon: "ri-shield-check-line" },
    { title: "文化传承", description: "尊重并传播亚洲各国的传统文化和工艺精神", icon: "ri-ancient-gate-line" },
    { title: "真实推荐", description: "坚持独立评测，不做虚假宣传，为用户提供真实参考", icon: "ri-heart-line" },
    { title: "全球视野", description: "立足亚洲，放眼全球，连接优质品牌与品质消费者", icon: "ri-global-line" },
  ],
  reputation: {
    stats: [
      { value: "200万+", label: "月活跃用户" },
      { value: "500+", label: "合作品牌" },
      { value: "10,000+", label: "推荐文章" },
      { value: "99.2%", label: "用户满意度" },
    ],
    media: [
      { name: "时尚芭莎", quote: "亚洲精品是发现亚洲新兴设计师品牌的最佳平台" },
      { name: "Vogue China", quote: "推荐的产品兼具品质与设计感，代表了亚洲制造的顶尖水平" },
      { name: "南方周末", quote: "以专业视角挖掘亚洲传统工艺的现代价值" },
      { name: "第一财经", quote: "连接亚洲优质品牌与中国消费者的重要桥梁" },
    ],
  },
  contact: {
    email: "hello@yazhoujingpin.com",
    phone: "400-888-9999",
    address: "上海市静安区南京西路1266号恒隆广场38层",
    wechat: "yazhoujingpin",
    workingHours: "周一至周五 9:00 - 18:00",
  },
};

export const timeline = [
  { year: "2020", title: "品牌创立", description: "亚洲精品正式成立，以博客形式开始分享亚洲好物推荐" },
  { year: "2021", title: "团队扩展", description: "买手团队覆盖中日韩三国，合作品牌突破100家" },
  { year: "2022", title: "平台升级", description: "完成平台化升级，月活跃用户突破50万" },
  { year: "2023", title: "品类拓展", description: "新增东南亚市场板块，覆盖国家和地区扩展至12个" },
  { year: "2024", title: "品牌认证", description: "推出亚洲精品认证体系，建立行业选品标准" },
  { year: "2025", title: "全球布局", description: "月活跃用户突破200万，成为亚洲精品推荐领域标杆平台" },
];